<template>
  <div>
    <Navbar></Navbar>
    <div v-if="historyNotEmpty">
      <div style="margin-top: 40px;" class="container border shadow">
        <div style="display:flex; justify-content: space-between;">
          <h5 style="margin-left:20px;">Product</h5>
          <h5 style="margin-left: 300px;">Total Harga</h5>
          <h5 style="margin-left: 4px;">Jumlah Produk</h5>
          <h5 style="margin-right:210px;">Waktu Transaksi</h5>
        </div>
      </div>
      <div
        class="container border shadow"
        style="margin-top: 20px;"
        v-for="item in this.$store.state.history"
        :key="item.id"
      >
        <div style="display:flex; justify-content: space-around;">
          <img
            style="width: 200px; height: 200px; margin-right: 50px;"
            :src="item.Products.image_url"
          />
          <p style="margin-top:80px; margin-right:100px; text-align: left; ">
            {{ item.Products.name }}
          </p>
          <p style="margin-top:80px; margin-right:100px; text-align: left;">
            {{ price(Number(item.Products.price) * Number(item.quantity)) }}
          </p>
          <p style="text-align: left; margin-top:80px; margin-right:100px;">{{ item.quantity }}</p>
          <p style="text-align: left; margin-top:80px; ">
            {{ new Date(item.createdAt).toString() }}
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      <h3 style="margin-top:100px; font-weight: bold;">
        Wah, anda belum pernah bertransaksi disini
      </h3>
      <p>Daripada dibiarin kosong, mending isi dengan barang-barang impianmu.</p>
      <p>Yuk, cek sekarang!</p>
      <button
        @click="goToHome"
        type="button"
        style="background-color:#039A0C; color:white; width: 200px;"
        class="btn"
      >
        Mulai Belanja
      </button>
    </div>
  </div>
</template>

<script>
import Navbar from "../components/Navbar.vue";
export default {
  data() {
    return {};
  },
  methods: {
    goToHome() {
      this.$router.push({ name: "Home" });
    },
    price(angka) {
      var rupiah = "";
      var angkarev = angka
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return (
        "Rp. " +
        rupiah
          .split("", rupiah.length - 1)
          .reverse()
          .join("")
      );
    }
  },
  created() {
    this.$store.dispatch("getHistory");
  },
  computed: {
    historyNotEmpty: function() {
      let data = this.$store.state.history.length;
      if (data === 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  components: {
    Navbar
  }
};
</script>

<style></style>
